package com.eladfinish.bible.contest.models

data class ClickableArea(
    val start: Int,
    val end: Int,
    val name: () -> Unit,
)

data class ClickableTextData(
    val text: String,
    val clickableAreas: List<ClickableArea>,
) {
    companion object {
        fun empty(): ClickableTextData =
            ClickableTextData(text = "", clickableAreas = emptyList())
    }
}
